import React, { useContext } from 'react';
import * as R from 'ramda';
import { array, object, number } from 'prop-types';

import { Feedbacks } from './feedbacks';
import { ParticipantsList } from './participants-list';
import { ParticipantsWrapper, HiddenParticipantsCounter } from './styles';
import { RefScrollableWrapper } from '../../../ui-helpers/scrollable-wrapper';


export function ParticipantsWithFeedbacks({
  users,
  contacts,
  feedbacks,
  participants,
  participantsVisibleLimit,
}) {
  const participantsIds = [...participants.users, ...participants.contacts];
  const hiddenParticipants = participantsIds.slice(participantsVisibleLimit);
  const visibleParticipants = participantsIds.slice(0, participantsVisibleLimit);
  const scrollableWrapper = useContext(RefScrollableWrapper);

  return (
    <ParticipantsWrapper
      content={
        <Feedbacks
          users={users}
          contacts={contacts}
          feedbacks={feedbacks}
          participants={participants}
        />
      }
      getPopupContainer={() =>
        scrollableWrapper || document.querySelector('body')
      }
      trigger="click"
      placement="bottomRight"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {!R.isEmpty(visibleParticipants)
        && <ParticipantsList
          users={users}
          contacts={contacts}
          participants={visibleParticipants}
          participantsVisibleLimit={participantsVisibleLimit}
          participantIconStyle={{
            width: '25px',
            height: '25px',
            ...(visibleParticipants.length > 1 && { marginLeft: '-15px' }),
          }}
        />}
      {!R.isEmpty(hiddenParticipants) && (
        <HiddenParticipantsCounter>{`+${hiddenParticipants.length}`}</HiddenParticipantsCounter>
      )}
    </ParticipantsWrapper>
  );
}

ParticipantsWithFeedbacks.propTypes = {
  users: object,
  contacts: object,
  feedbacks: array,
  participants: object.isRequired,
  participantsVisibleLimit: number,
};

ParticipantsWithFeedbacks.defaultProps = {
  users: {},
  contacts: {},
  feedbacks: [],
  participantsVisibleLimit: 3,
};



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/index.js